<template>
  <div class="table-action-wrapper d-flex flex-wrap align-items-center design-idea-review" ref="container">
    <p class="item-selected m-0" v-html="`Selected: ${Object.keys(ids).length} ${Object.keys(ids).length > 1 ? 'items' : 'item'}`"></p>
    <a @click.prevent="openPrintModal" href="#" class="btn btn-outline-success d-flex align-items-center ml-2" :class="{ disabled: Object.keys(ids).length === 0 }">
      <span>Print Artwork</span>
    </a>
  </div>
</template>
<script>
export default {
  data() {
    return {
      status: null,
      ids: {}
    }
  },
  mounted() {
    let listStatus = this.store.getter('extra_attributes.status', {})

    for (const [key, value] of Object.entries(listStatus)) {
      if (value.step && value.step.includes('print_artwork')) {
        this.status = value.id
        this.store.commit('query.status', {
          value: value.id,
          valueLabel: value.text,
          fieldLabel: 'Status'
        })
        break
      }
    }

    this.store.commit('cols.cb.hidden', false)
    this.$emit('change-filters', { search: '' }, { refresh: true, goToFirst: true })
    this.$emitter.on('table-list.refreshed', this.tableListRefreshed)
    this.$emitter.on('table-list.cb-changed', this.changeCb)
  },
  unmounted() {
    this.store.commit('query.status', null)
    this.store.commit('cols.cb.hidden', true)
    this.$emitter.off('table-list.refreshed', this.tableListRefreshed)
    this.$emitter.off('table-list.cb-changed', this.changeCb)
  },
  computed: {
    store() {
      return this.config?.store
    },
    rows() {
      let rows = {}
      Object.entries(this.store.getter('rows', {})).forEach(([indexRow, item]) => {
        rows[item._id] = item
        rows[item._id].indexRow = indexRow
      })
      return rows
    }
  },
  methods: {
    changeCb({ cb }) {
      Object.entries(cb).forEach(([id, checked]) => {
        if (checked) {
          this.ids[id] = true
        } else if (this.ids[id] != undefined) {
          delete this.ids[id]
        }
      })
    },
    tableListRefreshed(e) {
      Object.entries(this.ids).forEach(([id]) => {
        e.cb[id] = false
        delete this.ids[id]
      })
    },
    openPrintModal() {
      if (Object.keys(this.ids).length === 0) return
      this.$emitter.emit('Modal', {
        name: 'design-idea.print-artwork',
        items: this.getSelectedItems(),
        options: {
          status: this.status,
          statuses: this.store.getter('extra_attributes.status', []).reduce((acc, item) => {
            if (item.id) acc[item.id] = item
            return acc
          }, {})
        }
      })
    },
    getSelectedItems() {
      let items = {}
      Object.entries(this.ids).forEach(([id, item]) => {
        const design = this.rows?.[id]?.design_idea?.design
        items[id] = {
          name: design?.name || id,
          artworks: {
            front: design?.artworks?.front || '',
            back: design?.artworks?.back || '',
            cut: design?.artworks?.cut || ''
          }
        }
      })
      return items
    }
  },
  props: {
    config: Object
  }
}
</script>

<style lang="scss">
.table-action-wrapper.design-idea-review {
  .item-selected {
    width: 140px;
  }
  .input-group {
    a {
      width: 100%;
      &:hover {
        background: #d1eeff;
      }
    }
  }
}
</style>
